import { useLocation } from 'react-router-dom'
import { ProgressPage } from './ProgressPage'
import { StrategyLandscapePage } from './StrategyLandscapePage'

// DEC-039 makes Landscape the default. Progress is a separate contribution
// measure view; legacy Studio remains available only through retained internals.
export function StrategyPage() {
  const lens = new URLSearchParams(useLocation().search).get('lens')
  if (lens === 'progress') return <ProgressPage />
  return <StrategyLandscapePage />
}
